import { h, Component } from "preact";

import "./about_styles.css";
import "./home_styles.css";
import hotel_at_lake_img from "../images/hotel_at_lake.jpg";
import me_in_HI_img from "../images/me.jpg";
import headshot_img from "../images/celina-headshot-2025.png";

class About extends Component {
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const newTextElements = Array.from(
      document.querySelectorAll(".story-text")
    );
    const windowHeight = window.innerHeight;

    newTextElements.forEach((el, index) => {
      const rect = el.getBoundingClientRect();
      let rectCenter =
        rect.top +
        rect.height /
          2; /* center Y-coordinate of the element in the viewport */
    //   let rectCenter = rect.top;
    //   // For the first element, we consider only the top edge
    //   // For other elements, we still rely on the center.
    //   if(index !== 0){
    //     rectCenter += rect.height / 4; /* center Y-coordinate of the element in the viewport */
    //  }

      let newOpacity = 0;
      let newSize = 1.5; /* font size for smaller screens */

      // larger screens
      if (window.innerWidth > 961) {
          newOpacity = Math.max(Math.min((2 * (windowHeight - rectCenter)) / windowHeight, 1), 0.8);
          newSize += newOpacity / 1.5; /* so the size will range from 0 to 3 */
      }
      // smaller screens
      else {
        let helper = Math.max(Math.min((3 * rectCenter) / windowHeight, 1), 0.7);
        if(index == 0){
          newOpacity = Math.max(Math.min((3 * rectCenter) / windowHeight, 1), 0.9);
          newSize += helper / 2; /* so the size will range from 1.5 to 3 */
        }
        else{
          newOpacity = helper;
          newSize += helper / 2; /* so the size will range from 1.5 to 3 */
        }
       
      }

      el.style.opacity = newOpacity;
      el.style.fontSize = `${newSize}em`;
    });
  };

  render() {
    return (
      <div class="about">
        <div class="story-container">
          <div class="story-item">
            <img src={hotel_at_lake_img} alt="Lake Maggiore, from the hotel" />
            <h2 class="story-text">
              <p>
                Answering the classic question: "so tell me a little about
                yourself"... This page will tell you more about me, my goals,
                and why and how I made this website.
              </p>
            </h2>
          </div>
        </div>
        <div class="about-section-p1">
          <div class="quick-look-section">
            <div class="quick-look-bullets">
              <h3 class="quicklook-title">
                Education: University of Notre Dame
              </h3>
              <h3 class="quicklook-title">
                Major: Computer Science in the College of Engineering
              </h3>
              <h3 class="quicklook-title">
                Minor: Engineering Corporate Practice
              </h3>
              <h3 class="quicklook-title">Graduated: May 2024</h3>
              <div class="centered-frame"></div>
            </div>
            <figure class="frame-image">
              <img src={headshot_img} alt="my headshot" />
            </figure>
          </div>
          <div class="about-me-section">
            <h2 class="about-header">About Me</h2>
            <p>
              I live a fairly active lifestyle and love to learn. I
              enjoy just about any form of exercise: especially weight-lifting, yoga,
              and solidcore. In addition to staying active I enjoy reading, 
              normally several books at a time. 
              I’m an avid dog lover; I have four dogs back home in Virginia. When I have the time, 
              I volunteer at PAWS in Chicago (I'm doing it selfishly I swear I just want puppy time). 
              
              I also play the guitar; I’m a big music fan. I realized that my pattern recognition for software easily translates to music,
              so I spend a decent amount of time on music theory too. So that’s what I keep myself busy with
              when I’m not busy with work.
            </p>
          </div>
          <div class="about-site-section">
            <h2 class="about-header">About this Website</h2>
            <p>
              I made this website when I was trying to get my first job out of college. The funny thing is, after I got hired, 
              I asked the people who hired me and they said they didn't even look at it. That's okay I guess ... so maybe I can 
              just say whatever I want here ?? Just kidding!! Maybe not...
              
              Anyways, resumes nowadays are fairly cookie-cutter and usually just scanned by bots. I wanted this website to 
              be a showcase of all of my skills, past projects, and jobs (because there's just so much!!). Maybe this 
              means I'm more than just my resume ... I'm a bunch of HTML too :) 
            </p>
            <br />
            <p>
             This website was made with a JavaScript library called Preact. During my Senior Fall (2023) semester, I took Modern Web Development, 
             and I took advantage of new content from this class and some extra office hours with my teacher to make the website 
             you see now. During my summer at Apple, I found that I really like iOS Development -- my high school senior project 
             was about learning Swift and making an app interface... I didn't even think I was going to be a Computer Science major I was just
             doing it for fun! Then during Fall 2023 at Notre Dame, I found that I really like Web Development, too. For this website I used Preact as opposed to 
             React because I liked how Preact is a bit closer to HTML-style code which I'm more familiar with. 
             And honestly, I had a really cute NavBar that didn't translate to React easily so I said f-it let's do a Preact website.
             </p>
            <br />
            <p>
            After working at Apple in Summer 2023, I found myself excited to learn more about their
            web development process. One of my roommates that summer was working on one of the apple.com teams and I was always curious about it. 
            If you look at the <a href="https://www.apple.com/airpods-pro/">Apple AirPods Pro Page</a> you'll find something that truly excited me about Apple -- not only do they make 
            great technology products, they utilize their mastery in technology (in this case, 
            their mastery of web development) to showcase their products. The scrolling images along with the expanding text
            on this website are inspired by what I've been intrigued by on the Apple website.
            </p>
            <br />
            <p>
              I wanted this website to be easy to navigate, to have
              aesthetically pleasing scrolling animations, and to be an accurate
              reflection of myself.{" "}
            </p>
          </div>
          <div class="about-career-section">
            <h2 class="about-header">About my Career</h2>
            <p>
              I chose a career in software engineering/development because of my passion for problem-solving and constant learning. I love learning how things work. 
              So seeing how certain software and applications work during my past job experiences drove me to dig my heels into software engineering.
              I'm currently a Software Engineer at PayPal, working on a Ruby on Rails app as a backend engineer.
              <br />
            </p>
            <p>
            <br />As for past work experience, right out of college I went to GEICO to be a part of their Technology Development Program. I was a Fullstack Engineer -- creating APIs for their .NET app.
              
              My internship at Apple made me realize how much I love software development. I feel like a modern day artisan when I'm working on iOS code and I hope to do it again sometime ;)

              <br />
            </p>
            <p>
            <br />If you'd like to chat, please head 
              over to the <a href="/contact">Contact Me</a> section and reach out.
            </p>
          </div>
        </div>
        <div class="story-item">
        <img src={me_in_HI_img} alt="me in hawaii" />
        </div>
      </div>
      
    );
  }
}
export default About;
